// Bootstraps the AppointmentBooking.Wizard namespace so that model/view/
// collection files can reference it at module-evaluation time. Must be
// imported FIRST by index.js and by any file that touches
// AppointmentBooking.Wizard.Events.* or .Errors at module top level (e.g. in
// a `static { ... }` block, or views/wizard.js computed event keys).
//
// Uses per-key `??=` assignments so that if sub-module files evaluate before
// this file (due to Vite's eager glob expansion ordering), the namespace
// properties they already created are preserved rather than overwritten.
window.AppointmentBooking ??= {};

// The Wizard namespace doubles as the constructor class. We define the class
// here so that sub-modules imported later can attach to its static properties
// (Views, Models, Collections) and reference Events at module-evaluation
// time. The class body and constructor logic live in index.js — this file
// only provides the shell that index.js populates.
if (typeof window.AppointmentBooking.Wizard !== "function") {
  window.AppointmentBooking.Wizard = class Wizard {
    constructor(...args) {
      // Delegate to _init which is defined in index.js. This indirection
      // exists because _namespaces.js must be importable before index.js
      // finishes evaluating (sub-modules need the class and its static
      // properties at module-evaluation time), but the constructor body
      // depends on Models/Views that are only available after all
      // sub-modules have loaded.
      this._init(...args);
    }
  };
}

const W = window.AppointmentBooking.Wizard;
W.Views ??= { Mixins: {} };
if (!W.Views.Mixins) {
  W.Views.Mixins = {};
}
W.Collections ??= {};
W.Models ??= {};
W.Events ??= {
  Navigation: {
    backButtonClicked: "appointmentBookingWizardNavigation-backClicked",
    continueButtonClicked: "appointmentBookingWizardNavigation-continueClicked",
    continueButtonClickedWhileDisabled: "appointmentBookingWizardNavigation-continueClickedWhileDisabled",
  },
  Progress: {
    setCurrentStepProgress: "appointmentBookingWizardProgress-setCurrentStepProgress",
    jumpToStepClicked: "appointmentBookingWizardProgress-jumpToStepClicked",
  },
  AJAX: {
    loading: "loading.sparkle",
    loaded: "loaded.sparkle",
  },
};
W.Errors ??= _.extend({}, Backbone.Events);
W.AnalyticsDetails ??= { subtype: "appointment-booking-wizard" };
